@if (showCaptcha) {
  <div class="recaptcha recaptcha-wrap">
    <re-captcha #captchaRef [siteKey]="siteKey" (resolved)="handleSuccess($event)"></re-captcha>
    @if (formInvalid() && form.controls['recaptcha'].errors?.required) {
      <small class="text-danger ps-0 pb-0">
        reCAPTCHA is required.
      </small>
    }
  </div>
}